<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasEmployee="true"
      :hasFood="isDetail"
      :hasFoodKind="isDetail"
      :hasWarehouse="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    ></condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "detail") {
        let s = [
          { name: "StockTransferDate" },
          { name: "StockTransferNumber" },
          { name: "FromWarehouseNumber" },
          { name: "FromWarehouseName" },
          { name: "ToWarehouseNumber" },
          { name: "ToWarehouseName" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "TradeMemo" },
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "Qty" },
          { name: "Cost", headerText: "平均成本" },
          { name: "Memo" },
        ];
        if (window.localStorage["hasBatchNumber"] == "true") {
          s.push({ name: "BatchNumber" });
        }
        return s;
      } else if (this.reportType == "simple") {
        return [
          { name: "StockTransferDate" },
          { name: "StockTransferNumber" },
          { name: "FromWarehouseNumber" },
          { name: "FromWarehouseName" },
          { name: "ToWarehouseNumber" },
          { name: "ToWarehouseName" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "Memo" },
          { name: "CreateTime" },
          { name: "UpdateTime" },
        ];
      } else {
        return undefined;
      }
    },
    isDetail() {
      return this.reportType == "detail";
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getStockTransfer(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getStockTransfer(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printStockTransfer(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getStockTransfer(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
